/* LATUX Account Hub â€” application modal controller.
   Lifts overlays to <body> so the theme's transformed ancestors can't clip position:fixed. */
(function () {
  function init() {
    var ovs = Array.prototype.slice.call(document.querySelectorAll('.lxah-ov'));
    if (!ovs.length) return;
    ovs.forEach(function (ov) { document.body.appendChild(ov); });

    // Brighten the soft-grey helper copy (header paragraph + feature captions) a notch for
    // legibility, WITHOUT flattening the hierarchy against the pure-white labels/headings.
    // Gold accents (.m2-gold) are left alone. Light-DOM override so Mar's section liquid is
    // untouched (this stays in the JS baton).
    if (!document.getElementById('lxah-legibility')) {
      var lgs = document.createElement('style');
      lgs.id = 'lxah-legibility';
      lgs.textContent =
        '.lxah-ov .m2-desc{color:#dde1e7 !important}' +
        '.lxah-ov .m2-feat span:not(.m2-gold){color:#dde1e7 !important}' +
        // Tighten the modal header + form padding so the whole form fits without scrolling.
        '.lxah-ov .m2-head{padding-top:14px !important;padding-bottom:10px !important}' +
        '.lxah-ov .m2-body{padding-top:10px !important;padding-bottom:12px !important}' +
        // Post-submit "application under review" confirmation (replaces the form on success).
        '.lxah-ov .lxah-confirm{max-width:520px;margin:0 auto;padding:34px 22px 30px;text-align:center}' +
        '.lxah-ov .lxah-confirm-ico{width:56px;height:56px;line-height:56px;margin:0 auto 16px;border-radius:50%;background:rgba(204,0,0,.14);color:#CC0000;font-size:26px;font-weight:700}' +
        '.lxah-ov .lxah-confirm-h{font-family:"League Spartan",Inter,system-ui,sans-serif;font-size:26px;font-weight:800;color:#fff;margin:0 0 8px;letter-spacing:.01em}' +
        '.lxah-ov .lxah-confirm-p{font-family:Inter,system-ui,sans-serif;font-size:14px;line-height:1.5;color:#dde1e7;margin:0 auto 22px;max-width:400px}' +
        '.lxah-ov .lxah-confirm-btns{display:flex;gap:10px;justify-content:center;flex-wrap:wrap}' +
        '.lxah-ov .lxah-confirm-btn{display:inline-block;padding:12px 20px;border-radius:8px;font-family:Inter,system-ui,sans-serif;font-size:14px;font-weight:600;text-decoration:none;border:1px solid rgba(255,255,255,.22);color:#fff;transition:border-color .18s,background .18s}' +
        '.lxah-ov .lxah-confirm-btn:hover{border-color:#CC0000}' +
        '.lxah-ov .lxah-confirm-btn--primary{background:#CC0000;color:#ffffff;border-color:#CC0000}' +
        '.lxah-ov .lxah-confirm-btn--primary:hover{background:#e23b3b}';
      document.head.appendChild(lgs);
    }

    function closeAll() {
      ovs.forEach(function (ov) { ov.classList.remove('is-open'); });
      document.documentElement.style.overflow = '';
    }
    function open(key) {
      var ov = document.querySelector('.lxah-ov--' + key);
      if (!ov) return;
      closeAll();
      ov.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var emb = ov.querySelector('shopify-forms-embed');
      if (emb && emb.shadowRoot) {
        lxClearNames(emb.shadowRoot); lxFillWhite(emb.shadowRoot); lxTabOrder(emb.shadowRoot);
        setTimeout(function () { if (emb.shadowRoot) { lxClearNames(emb.shadowRoot); lxFillWhite(emb.shadowRoot); lxTabOrder(emb.shadowRoot); } }, 60);
        setTimeout(function () { if (emb.shadowRoot) lxTabOrder(emb.shadowRoot); }, 320);
      }
      var f = ov.querySelector('input, textarea');
      if (f) { try { f.focus(); } catch (e) {} }
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var opener = t.closest('[data-lxah-open]');
      if (opener) { e.preventDefault(); open(opener.getAttribute('data-lxah-open')); return; }
      if (t.closest('[data-lxah-close]')) { e.preventDefault(); closeAll(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeAll();
    });

    // If a submitted application errored, re-open its modal so the message is visible.
    var errored = document.querySelector('.lxah-ov .lxah-err');
    if (errored) {
      var host = errored.closest('.lxah-ov');
      if (host) {
        host.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
      }
    }

    // Phone auto-format as the user types: 561-340-3846
    function fmtPhone(v) {
      var d = v.replace(/\D/g, '').slice(0, 10), p = [];
      if (d.length) p.push(d.slice(0, 3));
      if (d.length > 3) p.push(d.slice(3, 6));
      if (d.length > 6) p.push(d.slice(6, 10));
      return p.join('-');
    }
    Array.prototype.forEach.call(document.querySelectorAll('.lxah-ov input[type="tel"]'), function (inp) {
      inp.setAttribute('inputmode', 'numeric');
      inp.setAttribute('maxlength', '12');
      if (!inp.getAttribute('placeholder')) inp.setAttribute('placeholder', 'Enter your phone number');
      inp.addEventListener('input', function () {
        var raw = inp.value, caret = inp.selectionStart;
        var before = raw.slice(0, caret).replace(/\D/g, '').length;
        var out = fmtPhone(raw);
        if (out === raw) return;
        inp.value = out;
        var pos = 0, n = 0;
        while (pos < out.length && n < before) { if (/\d/.test(out.charAt(pos))) n++; pos++; }
        try { inp.setSelectionRange(pos, pos); } catch (e) {}
      });
    });

    // Money auto-format for "Est. monthly spend": $10,000
    function fmtMoney(v) {
      var d = v.replace(/\D/g, '');
      if (!d) return '';
      d = d.replace(/^0+(?=\d)/, '');
      return '$' + Number(d).toLocaleString('en-US');
    }
    Array.prototype.forEach.call(document.querySelectorAll('.lxah-ov input[name="contact[Monthly spend]"]'), function (inp) {
      inp.setAttribute('inputmode', 'numeric');
      inp.addEventListener('input', function () {
        var raw = inp.value, caret = inp.selectionStart;
        var before = raw.slice(0, caret).replace(/\D/g, '').length;
        var out = fmtMoney(raw);
        if (out === raw) return;
        inp.value = out;
        var pos = 0, n = 0;
        while (pos < out.length && n < before) { if (/\d/.test(out.charAt(pos))) n++; pos++; }
        try { inp.setSelectionRange(pos, pos); } catch (e) {}
      });
    });

    // Fields turn light once filled, stay dark when empty
    function mark(el) { el.classList.toggle('lxah-filled', !!el.value.trim()); }
    var flds = document.querySelectorAll('.lxah-ov .lxah-field input, .lxah-ov .lxah-field textarea');
    Array.prototype.forEach.call(flds, function (el) {
      mark(el);
      el.addEventListener('input', function () { mark(el); });
      el.addEventListener('change', function () { mark(el); });
      el.addEventListener('blur', function () { mark(el); });
    });
    // catch browser autofill, which often fires no input event
    setTimeout(function () { Array.prototype.forEach.call(flds, mark); }, 250);
    setTimeout(function () { Array.prototype.forEach.call(flds, mark); }, 900);

    // Character counter for textareas with a maxlength + a .m2-count readout
    Array.prototype.forEach.call(document.querySelectorAll('.lxah-ov textarea[maxlength]'), function (t) {
      var wrap = t.closest('.m2-inp');
      var c = wrap ? wrap.querySelector('.m2-count') : null;
      if (!c) return;
      var max = t.getAttribute('maxlength');
      function upd() { c.textContent = t.value.length + '/' + max; }
      upd();
      t.addEventListener('input', upd);
    });

    /* â”€â”€ Two-column layout for the embedded Shopify Forms â”€â”€
       Shopify Forms renders each field as a grid item inside an OPEN shadow root.
       We reflow the fields into paired rows to match the LATUX application design
       (names together, email+phone, etc.); address / notes / submit stay full-width.
       Fields are matched by their label text so the hashed class names don't matter. */
    var LX_MAPS = {
      c: [ // Contractor 1107908 (supports single 'business address' OR split street/city/state/zip)
        { m: 'first name', o: 1, half: 1 }, { m: 'last name', o: 2, half: 1 },
        { m: 'business address', o: 3, half: 0 },
        { m: 'street', o: 3, half: 0 },
        { m: 'city', o: 4, half: 1 }, { m: 'state', o: 5, half: 1 }, { m: 'zip', o: 6, half: 1 },
        { m: 'email', o: 7, half: 1 }, { m: 'phone', o: 8, half: 1 },
        { m: 'company', o: 9, half: 1 }, { m: 'trade', o: 10, half: 1 },
        { m: 'license', o: 11, half: 1 }, { m: 'monthly spend', o: 12, half: 1 },
        { m: 'anything else', o: 13, half: 0 }
      ],
      s: [ // Distributor 1108096 (supports single 'business address' OR split street/city/state/zip)
        { m: 'first name', o: 1, half: 1 }, { m: 'last name', o: 2, half: 1 },
        { m: 'business address', o: 3, half: 0 },
        { m: 'street', o: 3, half: 0 },
        { m: 'city', o: 4, half: 1 }, { m: 'state', o: 5, half: 1 }, { m: 'zip', o: 6, half: 1 },
        { m: 'email', o: 7, half: 1 }, { m: 'phone', o: 8, half: 1 },
        { m: 'company', o: 9, half: 1 }, { m: 'website', o: 10, half: 1 },
        { m: 'resale', o: 11, half: 1 }, { m: 'tax id', o: 12, half: 1 }, { m: 'ein', o: 12, half: 1 },
        { m: 'territory', o: 13, half: 0 }, { m: 'stock', o: 14, half: 0 }, { m: 'volume', o: 14, half: 0 }
      ]
    };
    // Track fieldsets so the column count can follow viewport width (inline
    // !important beats Shopify's own stylesheet without a specificity gamble).
    var lxFieldsets = [];
    function lxSetCols(fs) {
      fs.style.setProperty('grid-template-columns', (window.innerWidth > 600 ? 'minmax(0, 1fr) minmax(0, 1fr)' : 'minmax(0, 1fr)'), 'important');
    }
    var lxResizeBound = false;
    // "Est. monthly spend" â†’ format as $1,000 (React-safe: native setter + input event).
    function lxMoneyFormat(sr) {
      var money = null;
      Array.prototype.forEach.call(sr.querySelectorAll('[class*="_formFieldContainer"] input'), function (i) {
        var c = i.closest('[class*="_formFieldContainer"]'), l = c && c.querySelector('label');
        if (l && l.textContent.toLowerCase().indexOf('monthly spend') > -1) money = i;
      });
      if (!money || money.__lxMoney) return;
      money.__lxMoney = true;
      money.setAttribute('inputmode', 'numeric');
      var setVal = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      function fmt() {
        var d = money.value.replace(/[^0-9]/g, '');
        if (!d) return;
        d = d.replace(/^0+(?=\d)/, '');
        var out = '$' + Number(d).toLocaleString('en-US');
        if (out === money.value) return;
        setVal.call(money, out);
        money.dispatchEvent(new Event('input', { bubbles: true }));
      }
      money.addEventListener('input', fmt);
      money.addEventListener('blur', fmt);
    }
    // Browser autofill sets the phone input's DOM value but Shopify's React state doesn't
    // follow, so the number shows in .value but not in the box. Re-sync via native setter +
    // input event. Autofill fires input with no/insertReplacementText inputType; real typing
    // is insertText â€” only sync the former so typing and caret stay untouched.
    function lxPhoneSync(sr) {
      var phone = sr.querySelector('[class*="_formPhoneInputContainer"] input');
      if (!phone || phone.__lxPhone) return;
      phone.__lxPhone = true;
      var setVal = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      var syncing = false;
      function sync() {
        if (syncing) return;
        syncing = true;
        setVal.call(phone, phone.value);
        phone.dispatchEvent(new Event('input', { bubbles: true }));
        syncing = false;
      }
      phone.addEventListener('input', function (ev) {
        if (!ev.inputType || ev.inputType === 'insertReplacementText' || ev.inputType === 'insertFromPaste') sync();
      });
      phone.addEventListener('change', sync);
      phone.addEventListener('blur', sync);
    }
    // The textarea's native <label> won't paint (Shopify shadow-DOM quirk) even though it
    // computes visible â€” so insert our own visible title above it and hide the broken one.
    function lxTextareaLabel(sr) {
      // Handle EVERY textarea (the distributor has multiple: Business address + the notes
      // field). For each: hide the white notch-mask, lift a visible title above it, and give
      // it a placeholder matched to its label.
      Array.prototype.forEach.call(sr.querySelectorAll('textarea'), function (ta) {
        var cont = ta.closest('[class*="_formFieldContainer"]');
        if (!cont || cont.__lxTaLbl) return;
        var nativeLbl = cont.querySelector('label');
        var text = (nativeLbl && nativeLbl.textContent.trim()) || '';
        if (!text) return; // skip the label-less honeypot textarea
        cont.__lxTaLbl = true;
        cont.classList.add('lx-ta-field');
        nativeLbl.style.setProperty('display', 'none', 'important');
        var d = document.createElement('div');
        d.textContent = text;
        d.style.cssText = 'order:-1;color:#ffffff;font-family:Inter,system-ui,sans-serif;font-size:12px;font-weight:600;letter-spacing:.005em;margin:0 0 3px 0;';
        cont.insertBefore(d, cont.firstChild);
        var low = text.toLowerCase();
        if (!ta.getAttribute('placeholder')) {
          var ph = 'Questions or detailsâ€¦';
          if (low.indexOf('address') > -1) ph = 'Street address, city, state, ZIP code';
          else if (low.indexOf('stock') > -1 || low.indexOf('volume') > -1) ph = 'Product lines, expected volume, current accountsâ€¦';
          ta.setAttribute('placeholder', ph);
        }
        // Business address is a single-line box like the other inputs (not a tall multi-line box).
        if (low.indexOf('address') > -1) { ta.rows = 1; cont.classList.add('lx-ta-addr'); }
        else { ta.rows = 2; } // shrink the notes / "what you'd stock" boxes from 3 rows so the form fits
      });
    }
    // Shopify Forms prefills First/Last name AND email from the LOGGED-IN customer, so the
    // owner (or any signed-in applicant) sees the form pre-populated. Edwin wants it to open
    // blank. Clear those fields React-safely (native setter + input event) â€” but only until
    // the user actually interacts, so a real applicant's typing/paste/autofill is never wiped.
    // Real user input carries an inputType; our synthetic clear event does not â€” that's the tell.
    function lxClearNames(sr) {
      if (!sr) return;
      var setVal = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
      Array.prototype.forEach.call(sr.querySelectorAll('[class*="_formFieldContainer"] input'), function (inp) {
        var c = inp.closest('[class*="_formFieldContainer"]'), l = c && c.querySelector('label');
        var t = l ? l.textContent.toLowerCase() : '';
        if (t.indexOf('first name') === -1 && t.indexOf('last name') === -1 && t.indexOf('email') === -1) return;
        if (!inp.__lxNameBound) {
          inp.__lxNameBound = true;
          inp.addEventListener('input', function (ev) { if (ev.inputType) inp.__lxTouched = true; });
        }
        if (!inp.__lxTouched && inp.value) {
          setVal.call(inp, '');
          inp.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    }
    // Business-address autofill: Chrome pops its address-autofill on this box but, since
    // Shopify gives it no address semantics (autocomplete="off"), it surfaces the saved
    // EMAIL instead of a street address. Tag it autocomplete="street-address" so Chrome
    // offers the saved ADDRESS (or nothing â†’ blank), never the email. Idempotent per field.
    function lxAddressAutofill(sr) {
      if (!sr) return;
      Array.prototype.forEach.call(sr.querySelectorAll('[class*="_formFieldContainer"]'), function (cont) {
        var l = cont.querySelector('label');
        if (!l || l.textContent.toLowerCase().indexOf('address') === -1) return;
        var f = cont.querySelector('input, textarea');
        if (!f || f.__lxAddr) return;
        f.__lxAddr = true;
        f.setAttribute('autocomplete', 'street-address');
      });
    }
    // Tab order: CSS `order` reflows the grid visually, but Tab still follows DOM source order
    // (Shopify emits First,Email,Last,Phoneâ€¦), so Tab jumps around. Re-map tabindex to the
    // VISUAL order (the same `order` we set on each grid cell) so Tab flows leftâ†’right, topâ†’bottom.
    // React-safe (tabindex is an attribute; the DOM structure isn't touched). Runs on modal open
    // when the fields are visible (getBoundingClientRect skips the off-screen honeypot).
    function lxTabOrder(sr) {
      if (!sr) return;
      var fs = sr.querySelector('[class*="_formFieldset"]');
      if (!fs) return;
      var cells = Array.prototype.slice.call(fs.children);
      cells.sort(function (a, b) { return (parseInt(a.style.order) || 90) - (parseInt(b.style.order) || 90); });
      var ti = 1;
      cells.forEach(function (cell) {
        if (!cell.querySelectorAll) return;
        Array.prototype.forEach.call(cell.querySelectorAll('input,textarea,select,button'), function (el) {
          if (el.type === 'hidden' || el.disabled) return;
          var r = el.getBoundingClientRect();
          if (r.width < 1 || r.height < 1 || r.right < 1 || r.bottom < 1) return; // skip hidden/off-screen honeypot
          el.tabIndex = ti++;
        });
      });
      var sub = null; // submit button lives outside the fieldset â†’ make it last
      Array.prototype.forEach.call(sr.querySelectorAll('button'), function (b) { if (/submit|application/i.test(b.textContent || '')) sub = b; });
      if (sub) sub.tabIndex = ti++;
    }
    // Fill-white: once a field holds a value, flip it to a white box with dark text so it's
    // obvious at a glance what's done vs. still empty (empty stays dark). Phone counts as filled
    // only once real digits follow the country code (the "+1" prefix alone is not "filled").
    function lxFillWhite(sr) {
      if (!sr) return;
      function isFilled(f) {
        var v = f.value || '';
        if (f.type === 'tel' || /_formPhoneInputField/.test(f.className)) return v.replace(/\D/g, '').length > 1;
        return !!v.trim();
      }
      var fields = sr.querySelectorAll('input[class*="_formInputField"],textarea[class*="_textArea"],input[class*="_formPhoneInputField"]');
      Array.prototype.forEach.call(fields, function (f) {
        if (!f.__lxFill) {
          f.__lxFill = true;
          var t = function () { f.classList.toggle('lx-filled', isFilled(f)); };
          f.addEventListener('input', t);
          f.addEventListener('change', t);
          f.addEventListener('blur', t);
        }
        f.classList.toggle('lx-filled', isFilled(f));
      });
    }
    // Post-submit confirmation. The Shopify Forms embed submits in-place (AJAX) and shows only a
    // small inline "received" note â€” it never triggers the old page-reload flash that used to show
    // Edwin's "application under review" popup. So watch the embed: once a submit fires AND the form
    // fieldset disappears (Shopify's success = form removed), show the confirmation with the two
    // buttons (Go to my account / Back to home). Gated on submit so validation errors don't trip it.
    function lxShowConfirm(ov) {
      if (!ov || ov.__lxConfirm) return;
      ov.__lxConfirm = true;
      var emb = ov.querySelector('shopify-forms-embed');
      if (emb) emb.style.display = 'none';
      var host = ov.querySelector('.m2-body') || (emb && emb.parentNode) || ov;
      var box = document.createElement('div');
      box.className = 'lxah-confirm';
      box.innerHTML =
        '<div class="lxah-confirm-ico" aria-hidden="true">&#10003;</div>' +
        '<h3 class="lxah-confirm-h">Application received</h3>' +
        '<p class="lxah-confirm-p">Your account is created and your application is in review. We&rsquo;ll email you the moment you&rsquo;re approved. Until then you&rsquo;ll see standard retail prices.</p>' +
        '<div class="lxah-confirm-btns">' +
        '<a class="lxah-confirm-btn lxah-confirm-btn--primary" href="/customer_authentication/login?return_to=%2Fpages%2Fdashboard">Go to my dashboard &rarr;</a>' +
        '<a class="lxah-confirm-btn" href="/">Continue shopping &rarr;</a>' +
        '</div>';
      host.appendChild(box);
    }
    function lxSuccessWatch(embed) {
      if (!embed || embed.__lxSucc) return;
      var sr = embed.shadowRoot;
      if (!sr) return;
      var form = sr.querySelector('form');
      if (!form) return;
      embed.__lxSucc = true;
      var submitted = false;
      form.addEventListener('submit', function () { submitted = true; });
      Array.prototype.forEach.call(sr.querySelectorAll('button'), function (b) {
        if (b.type === 'submit' || /submit|application/i.test(b.textContent || '')) b.addEventListener('click', function () { submitted = true; });
      });
      var obs = new MutationObserver(function () {
        var ov = embed.closest('.lxah-ov');
        if (!submitted || embed.__lxConfirmShown || !ov || !ov.classList.contains('is-open')) return;
        var fsNow = sr.querySelector('[class*="_formFieldset"]');
        if (!fsNow || !fsNow.offsetParent) {
          embed.__lxConfirmShown = true;
          lxShowConfirm(ov);
        }
      });
      obs.observe(sr, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    }
    function lxApplyGrid(embed) {
      if (embed.__lxGrid) return true;
      var ov = embed.closest ? embed.closest('.lxah-ov') : null;
      if (!ov) return true; // not one of ours â€” leave it alone
      var key = ov.classList.contains('lxah-ov--c') ? 'c'
              : (ov.classList.contains('lxah-ov--s') ? 's' : null);
      if (!key) return true;
      var sr = embed.shadowRoot;
      if (!sr) return false; // not hydrated yet â€” retry later
      var fs = sr.querySelector('[class*="_formFieldset"]');
      if (!fs) return false;
      fs.style.setProperty('display', 'grid', 'important');
      fs.style.setProperty('gap', '6px 16px', 'important');
      fs.style.setProperty('align-items', 'start', 'important');
      fs.style.setProperty('width', '100%', 'important');
      fs.style.setProperty('box-sizing', 'border-box', 'important');
      lxSetCols(fs);
      // Neutralize Shopify's 450px max-width + centering so the form runs full-width
      // inside the modal padding (matches Edwin's original edge-to-edge layout).
      var anc = fs.parentNode, guard = 0;
      while (anc && anc !== sr && guard < 8) {
        anc.style.setProperty('max-width', 'none', 'important');
        anc.style.setProperty('width', '100%', 'important');
        anc.style.setProperty('box-sizing', 'border-box', 'important');
        // Zero the Shopify wrapper's own left/right padding so the grid runs edge-to-edge in
        // the modal body (its side padding was what pushed the right column past the edge).
        anc.style.setProperty('padding-left', '0', 'important');
        anc.style.setProperty('padding-right', '0', 'important');
        var acs = getComputedStyle(anc);
        if (acs.display === 'grid' || acs.display === 'inline-grid') {
          anc.style.setProperty('justify-items', 'stretch', 'important');
          anc.style.setProperty('justify-content', 'stretch', 'important');
          anc.style.setProperty('grid-template-columns', 'minmax(0, 1fr)', 'important');
        } else if (acs.display === 'flex' || acs.display === 'inline-flex') {
          anc.style.setProperty('justify-content', 'stretch', 'important');
          anc.style.setProperty('align-items', 'stretch', 'important');
        }
        anc = anc.parentNode;
        guard++;
      }
      // Our full-width change trips Shopify's container-query label animation, so the
      // floating label can stay in its empty-state spot and overlap the value. Force the
      // floated position whenever a field is filled or focused (empty stays as placeholder).
      if (!sr.querySelector('style[data-lxlabel]')) {
        var ls = document.createElement('style');
        ls.setAttribute('data-lxlabel', '1');
        // Lift Shopify's floating label OUT of the box to sit ABOVE the field, matching
        // Edwin's original .lxah-field label (white, 12px, Inter 600). order:-1 forces it
        // first in the flex column regardless of DOM order; input padding reset since the
        // label no longer lives inside the box.
        ls.textContent =
          '[class*="_formInputFieldLabel"]{position:static !important;order:-1 !important;transform:none !important;' +
          'font-family:Inter,system-ui,sans-serif !important;font-size:12px !important;font-weight:600 !important;' +
          'color:#ffffff !important;letter-spacing:.005em !important;line-height:1.2 !important;' +
          'margin:0 0 3px 0 !important;padding:0 !important;max-width:none !important}' +
          'input[class*="_formInputField"],textarea[class*="_formInputField"]{padding-top:6px !important;padding-bottom:6px !important}' +
          // Compress the Shopify form heading ("Apply for Contractor Pricing") so the whole form fits without scrolling.
          '[class*="_textHeading"]{font-size:17px !important;margin-bottom:2px !important}' +
          // Phone field: shrink the country/flag box and bottom-align it to the number
          // input so the whole thing sits on one line, matched heights (38px).
          '[class*="_formPhoneInputContainer"]{grid-template-columns:58px minmax(0,1fr) !important;align-items:end !important;column-gap:8px !important}' +
          '[class*="_formPhoneInputContainer"] .phone-country-selector{align-self:end !important}' +
          '[class*="_formPhoneInputContainer"] input{padding-top:6px !important;padding-bottom:6px !important}' +
          'button[class*="_selectToggle"]{height:30px !important;min-height:0 !important;align-items:center !important;padding-left:8px !important;padding-right:6px !important}' +
          // Textarea ("Anything else?") uses class _textArea, not _formInputField, so it kept
          // a 26.5px hollow top padding â€” match it to the inputs (11px) so the box looks even.
          // Match the textarea EXACTLY to the text inputs (which render even corners): the
          // key is overflow:clip â€” with overflow:auto a textarea's scroll viewport leaves the
          // TOP corners square while the bottom round. clip + same radius/shadow = even box.
          '[class*="_textArea"]{padding:6px 15px !important;box-sizing:content-box !important;overflow:clip !important;border-radius:5px !important;border:0 !important;box-shadow:rgba(32,32,32,.2) 0 0 0 1px !important;outline:none !important}' +
          // Dark field styling to match Edwin's original design: dark boxes, white text,
          // subtle border, grey placeholder, gold focus ring. Applies to all field types.
          'input[class*="_formInputField"],textarea[class*="_textArea"],input[class*="_formPhoneInputField"]{background:#0e1116 !important;color:#ffffff !important;border:1px solid rgba(255,255,255,.18) !important;box-shadow:none !important}' +
          // Filled fields flip to a white box + dark text (empty stays dark) so it's obvious what's done.
          'input[class*="_formInputField"].lx-filled,textarea[class*="_textArea"].lx-filled,input[class*="_formPhoneInputField"].lx-filled{background:#ffffff !important;color:#14161b !important;border-color:rgba(0,0,0,.2) !important}' +
          'input[class*="_formInputField"]::placeholder,textarea[class*="_textArea"]::placeholder,input[class*="_formPhoneInputField"]::placeholder{color:#7c828b !important;opacity:1 !important}' +
          'input[class*="_formInputField"]:focus,textarea[class*="_textArea"]:focus,input[class*="_formPhoneInputField"]:focus{border-color:#CC0000 !important;box-shadow:0 0 0 3px rgba(204,0,0,.14) !important}' +
          'button[class*="_selectToggle"]{background:#0e1116 !important;border:1px solid rgba(255,255,255,.18) !important;color:#ffffff !important;box-shadow:none !important}' +
          // Hide Shopify's white floating-label notch mask (_formFieldContainer::before) on the
          // textarea field â€” it's orphaned now that the label sits above, and shows as a white
          // bar on the dark box. Scoped to the textarea's container via the lx-ta-field class.
          '.lx-ta-field::before{display:none !important}' +
          // Bump the country flag up from ~27px so it isn't dwarfed in the box. The flag img
          // has max-width:100% and its container collapsed, so also free the container + drop
          // the cap; verified it still fits alongside the dropdown arrow in the 58px button.
          '[class*="_selectToggleText"]{overflow:visible !important;max-width:none !important;width:auto !important}' +
          '[class*="_flagIcon"]{width:32px !important;height:auto !important;max-width:none !important}' +
          // Business address: single-line height matching the other input boxes (rows=1 + no min-height).
          '.lx-ta-addr textarea{min-height:0 !important;height:auto !important}';
        sr.appendChild(ls);
      }
      lxFieldsets.push(fs);
      lxMoneyFormat(sr);
      lxPhoneSync(sr);
      lxTextareaLabel(sr);
      if (!lxResizeBound) {
        lxResizeBound = true;
        window.addEventListener('resize', function () { lxFieldsets.forEach(lxSetCols); });
      }
      var map = LX_MAPS[key];
      Array.prototype.forEach.call(fs.children, function (c) {
        var lbl = c.querySelector ? c.querySelector('label') : null;
        var txt = (lbl ? lbl.textContent : '').toLowerCase();
        var hit = null;
        if (txt) { for (var i = 0; i < map.length; i++) { if (txt.indexOf(map[i].m) > -1) { hit = map[i]; break; } } }
        if (hit) {
          c.style.setProperty('order', String(hit.o), 'important');
          c.style.setProperty('grid-column', hit.half ? 'auto' : '1 / -1', 'important');
        } else {
          // anything not a known field (submit, consent line, hidden, error region)
          // â†’ full width, pushed to the bottom (order stays high even if it hydrates late)
          c.style.setProperty('order', '90', 'important');
          c.style.setProperty('grid-column', '1 / -1', 'important');
        }
      });
      embed.__lxGrid = true;
      return true;
    }
    function lxGridSweep() {
      var es = document.querySelectorAll('shopify-forms-embed');
      var allDone = true;
      Array.prototype.forEach.call(es, function (e) { if (!lxApplyGrid(e)) allDone = false; lxAddressAutofill(e.shadowRoot); lxClearNames(e.shadowRoot); lxFillWhite(e.shadowRoot); lxTabOrder(e.shadowRoot); lxSuccessWatch(e); });
      return es.length > 0 && allDone;
    }
    var lxTries = 0;
    var lxTimer = setInterval(function () {
      lxTries++;
      if (lxGridSweep() || lxTries > 40) clearInterval(lxTimer);
    }, 300);
    lxGridSweep();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
